import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import {
    getdiscrepancyCollection,
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
    getdiscrepancyDetails,
    DiscrepancyDetailsParam,
    DiscrepancyDetailsResult,
} from "@tKgpco/Services/DiscrepancyService";
import { getRMADetails, RMADetailsParam, RMADetailsResult } from "@tKgpco/Services/RMAService";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import loadRMACollection from "@tKgpco/Store/Data/RMA/Handlers/loadRMACollection";
import loadRMAMessages from "@tKgpco/Store/Data/RMA/Handlers/LoadRMAMessages";

type HandlerType = CustomApiHandler<RMADetailsParam, RMADetailsResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.dispatch({
        type: "Custom/RMA/BeginLoadRMADetailsCollection",
        params: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRMADetails(props.parameter);
};

export const DispatchCompleteRMADetailsCollection: HandlerType = props => {
    props.dispatch({
        type: "Custom/RMA/CompleteLoadRMADetailsCollection",
        result: props.apiResult,
    });
};

export const DispatchLoadRMAListCollection: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;
    const parameters = state.KGPState.RMAStore.RMACollectionParams;

    props.dispatch(loadRMACollection({ ...parameters }));
};

export const DispatchLoadRMAMessages: HandlerType = props => {
    props.dispatch(loadRMAMessages({ Id: props.parameter.rmaNumber, type: "RMAHistory", size: 4 }));
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteRMADetailsCollection,
    DispatchLoadRMAListCollection,
    DispatchLoadRMAMessages,
];

export const loadRMADetailsCollection = createHandlerChainRunner(chain, "loadRMADetailsCollection");
export default loadRMADetailsCollection;
